export const buildAddressOption = (value, label) => {
  if (!value) return null;

  return {
    value,
    label: label || value,
  };
};

export const buildAddressFormState = (data = {}) => ({
  addressCountry: buildAddressOption(data.addressCountry, data.addressCountryName),
  addressState: buildAddressOption(data.addressState, data.addressStateName),
  addressCity: buildAddressOption(data.addressCity, data.addressCityName),
  addressStreet: data.addressStreet || '',
  addressColony: data.addressColony || '',
  addressZip: data.addressZip || '',
  addressExtNumber: data.addressExtNumber || '',
  addressIntNumber: data.addressIntNumber || '',
});
